<template>
  <section class="red-separator" :class="{ 'is-webp': isWebpSupported }">
    <h1 class="red-separator__header">
      It’s you against the world<br />
      in Mini DAYZ
    </h1>
  </section>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "RedSeparator",
  data() {
    return {};
  },
  computed: {
    ...mapGetters("settings", {
      isWebpSupported: "isWebpSupported"
    })
  }
};
</script>
<style scoped lang="scss" type="text/scss">
@import "../../../assets/styles/vars";
@import "../../../assets/styles/mixins";
.red-separator {
  font-size: 1rem;
  padding: 2.5em 0;
  color: #000;
  text-align: center;
  background: url("../../../assets/img/bg/section-divider.jpg?size=1280") center;

  @media (max-width: $screen-lg-down) {
    font-size: 0.85rem;
    background-image: url("../../../assets/img/bg/section-divider.jpg?size=1280");
  }

  @media (max-width: $screen-md-down) {
    font-size: 0.65rem;
    background-image: url("../../../assets/img/bg/section-divider.jpg?size=1024");
  }

  @media (max-width: $screen-sm-down) {
    font-size: 0.55rem;
    background-image: url("../../../assets/img/bg/section-divider.jpg?size=768");
  }

  @media (max-width: $screen-xs-down) {
    font-size: 0.4rem;
    padding: 3.5em 0;
    background-image: url("../../../assets/img/bg/section-divider.jpg?size=360");
  }

  &.is-webp {
    background: url("../../../assets/img/bg/section-divider.webp?size=1280")
      center;

    @media (max-width: $screen-lg-down) {
      background-image: url("../../../assets/img/bg/section-divider.webp?size=1280");
    }

    @media (max-width: $screen-md-down) {
      background-image: url("../../../assets/img/bg/section-divider.webp?size=1024");
    }

    @media (max-width: $screen-sm-down) {
      background-image: url("../../../assets/img/bg/section-divider.webp?size=768");
    }

    @media (max-width: $screen-xs-down) {
      background-image: url("../../../assets/img/bg/section-divider.webp?size=360");
    }
  }
}

.red-separator__header {
  margin: 0;
  font-size: em(50);
  line-height: 1.23;
}
</style>
